module.exports = __webpack_public_path__ + "static/media/bscscan-logo.8ad661cb.svg";